module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/excess-speed-report/excess-speed-report.component.css
// module id = ./src/app/excess-speed-report/excess-speed-report.component.css
// module chunks = main